import { useState, useEffect } from "react";
import { FiMenu, FiX } from "react-icons/fi";

const Navbar = () => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = open ? "hidden" : previousOverflow;

        return () => {
            document.body.style.overflow = previousOverflow;
        };
    }, [open]);

    const data = [
        { name: "Home", link: "/#header" },
        { name: "About", link: "/#about" },
        { name: "Projects", link: "/#projects" },
        { name: "Contact", link: "/#contact" },
    ]

    return (
        <nav className="fixed top-0 w-full z-40">
            {/* Top Bar */}
            <div className="border-b border-black bg-white">
                <div className="max-w-7xl mx-auto flex items-center justify-between p-4">
                    <div className="font-bold text-primary leading-none text-lg">
                        DRN <br /> <span className="text-black">PORTFOLIO</span>
                    </div>
                    {/* Desktop */}
                    <div className="hidden lg:flex font-bold gap-6 xl:gap-8 text-base xl:text-lg">
                        {data.map((item, index) => (
                            <a key={index} href={item.link} className="hover:underline">
                                {item.name}
                            </a>
                        ))}
                    </div>
                    {/* Single Toggle Button */}
                    <button type="button" onClick={() => setOpen(!open)} className="lg:hidden relative z-50 p-1" aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open} aria-controls="mobile-navigation">
                        {open ? <FiX size={28} /> : <FiMenu size={28} />}
                    </button>
                </div>
            </div>

            {/* Overlay */}
            <button type="button" onClick={() => setOpen(false)} aria-label="Close menu" tabIndex={open ? 0 : -1} className={`fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity duration-300 lg:hidden z-30 ${open ? "opacity-100 visible" : "opacity-0 invisible"}`} />

            {/* Sidebar */}
            <div id="mobile-navigation" aria-hidden={!open} className={`fixed top-0 right-0 h-full w-72 max-w-[85vw] bg-white border-l border-black shadow-xl transform transition-transform duration-300 lg:hidden z-40 ${open ? "translate-x-0 visible" : "translate-x-full invisible"}`}>
                <div className="flex flex-col gap-6 px-6 pt-16 font-bold">
                    {data.map((item, i) => (
                        <a key={i} href={item.link} onClick={() => setOpen(false)} className="hover:underline">
                            {item.name}
                        </a>
                    ))}
                </div>
            </div>
        </nav>
    )
}

export default Navbar
